import { render, staticRenderFns } from "./AcceptAccountFrontpage.vue?vue&type=template&id=40fba6db&"
import script from "./AcceptAccountFrontpage.vue?vue&type=script&lang=js&"
export * from "./AcceptAccountFrontpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports